import { Button, Col, Form, Input, Row, Space, theme, Table, message, Tag, Select, DatePicker, Tooltip, Segmented, Image } from 'antd';
import React, { useEffect, useState } from 'react';
import LoadingBase from '../../components/LoadingBase';
import '../../css/listbook-page.css';
import { getListOrders, getListShops, getOrderDetailById, exportOrderBySelected, getOrderItemDetail, updateOrderItem, updateOrderById, getListProvider, getListSuppiler, updateSupplierByOrderId, searchSkuPrintlogistic, updateAndExportOrderBySelected, exportOrderSelected } from '../../services/apis';
import { DATE_FORMAT, HeaderTableCus, OPTION_TIME, RATE_EURO_TO_USD, SORT_TYPE, STATUS_ORDER, statusOrderMap, TYPE_STATUS_SKU } from '../../constants/constants';
import { CloseCircleOutlined, FileExcelOutlined, SearchOutlined, ShopOutlined } from '@ant-design/icons';
import { filterOption, filterShopsByUser, formatNumber } from '../../utils/funcHelper';
import dayjs from 'dayjs';
import { consoleLogUtil } from '../../utils/consoleLogUtil';
import { useSelector } from 'react-redux';
import OrderDetailModal from './modal/OrderDetailModal';
import ItemDetailModal from './modal/ItemDetailModal';
import ModalSelectedOrder from './modal/ModalSelectedOrder';
import ModalUpdatePrintOders from './modal/ModalUpdatePrintOders';
import ModalExportOrderSelected from './modal/ModalExportOrderSelected';

const ListOrderPage = () => {
    const { token } = theme.useToken();
    const [form] = Form.useForm();

    const initialValues = {
        keyword: '',
        status: null,
        date: [dayjs().startOf('day'), dayjs().endOf('day')]
    };

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [orderSelected, setOrderSelected] = useState();
    const [itemSelected, setItemSelected] = useState();
    const [dataShops, setDataShops] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalItemOpen, setIsModalItemOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(20);
    const [totalRecords, setTotalRecords] = useState(0);
    const userReducer = useSelector((state) => state?.userReducer?.data);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [showModalSelected, setShowModalSelected] = useState(false);
    const [optionTime, setOptionTime] = useState(1);
    const [sortType, setSortType] = useState(SORT_TYPE[0].value);
    const [providers, setProviders] = useState([]);
    const [printers, setPrinters] = useState([]);
    const [skus, setSkus] = useState([]);
    const [showModalUpdatePrinter, setShowModalUpdatePrinter] = useState(false);
    const [showModalExportOrderSelected, setShowModalExportOrderSelected] = useState(false);

    const { RangePicker } = DatePicker;

    const columns = [
        {
            title: 'Image',
            dataIndex: 'first_sku_image',
            key: 'first_sku_image',
            align: 'center',
            width: 60,
            render: (text, record, index) => <div style={{ padding: 1 }}><Image src={text} width={60} height={60} /></div>,
        },
        {
            title: 'Order ID',
            dataIndex: 'order_id',
            key: 'order_id',
            width: 100,
            align: 'center',
            render: (text, record, index) => <div>
                <a style={{ paddingLeft: 8, paddingRight: 8 }} onClick={() => getDataOrderDetail(text)}>{text}</a>
            </div>,
        },
        {
            title: 'Customer',
            dataIndex: 'customer',
            key: 'customer',
            width: 200,
            render: (text, record, index) => <div
                onClick={() => getDataOrderDetail(record?.order_id)}
                style={{
                    paddingLeft: 12, paddingRight: 12
                }}>
                {text}
            </div>,
        },
        {
            title: 'Shop',
            width: 200,
            render: (text, record, index) => <div>
                <Tag icon={<ShopOutlined />} color="#3b5999">
                    {record?.custom_code} - {record?.shop_name}
                </Tag>
            </div>,
        },
        {
            title: 'Order status',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            width: 150,
            render: (text, record, index) =>
                calculatorStatusOrder(record)

        },
        {
            title: 'Titkok status',
            dataIndex: 'tiktok_status',
            key: 'tiktok_status',
            align: 'center',
            width: 150,
        },
        {
            title: 'Printer',
            dataIndex: 'printer_name',
            key: 'printer_name',
            align: 'center',
            width: 150,
        },
        {
            title: 'Sale price',
            dataIndex: 'total',
            key: 'total',
            align: 'center',
            width: 180,
            render: (text, record, index) => <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>£ {formatNumber(text, 2)}</div>,
        },
        {
            title: 'Est earned',
            dataIndex: 'est_settlement_amount',
            key: 'est_settlement_amount',
            align: 'center',
            width: 150,
            render: (text, record, index) => <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>{formatNumber(text * RATE_EURO_TO_USD, 2)} $</div>,
        },
        {
            title: 'Total cost',
            align: 'center',
            width: 150,
            render: (text, record, index) => <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>{calculatorTotalCost(record)} $</div>,
        },
        {
            title: 'Est profit',
            align: 'center',
            width: 150,
            render: (text, record, index) => <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>{record?.est_settlement_amount ? calculatorProfit(record) : 'N/A'} $</div>,
        },
        {
            title: 'Items',
            align: 'center',
            dataIndex: 'items_count',
            key: 'items_count',
            width: 100,
            render: (text, record, index) => <div style={{
                paddingLeft: 12, paddingRight: 12
            }}>
                {text} items
            </div>,
        },
        {
            title: 'Created At',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 150,
            align: 'center',
            render: (text, record, index) => <div>{dayjs(text).format('DD-MM-YYYY HH:mm:ss')}</div>,
        },
    ];

    const expandColumns = [
        {
            title: 'Image',
            dataIndex: 'sku_image',
            key: 'sku_image',
            align: 'center',
            width: 60,
            render: (text, record, index) => <div style={{ padding: 1 }}><Image src={text} width={60} height={60} /></div>,
        },
        {
            title: 'Name',
            dataIndex: 'product_name',
            key: 'product_name',
            render: (text, record, index) => <div style={{
                display: 'flex', flexDirection: 'column', cursor: 'pointer'
            }}>
                <div style={{
                    paddingLeft: 6, paddingRight: 12, wordWrap: "break-word",
                    whiteSpace: "normal",
                }}><Tooltip title={text}><strong>{text?.length > 100 ? text?.substring(0, 100)?.concat("...") : text}</strong></Tooltip></div>
            </div>,
        },
        {
            title: 'Satus',
            dataIndex: 'status',
            align: 'center',
            key: 'status',
            render: (text, record, index) => <div>{calculatorStatusOrder(record)}</div>,
        },
        {
            title: 'Sale price',
            dataIndex: 'sale_price',
            align: 'center',
            key: 'sale_price',
            render: (text, record, index) => <div>{text} $</div>,
        },
        {
            title: 'SKU name',
            align: 'center',
            dataIndex: 'sku_name',
            key: 'sku_name',
        },
        {
            title: 'Tracking number',
            dataIndex: 'tracking_number',
            key: 'tracking_number',
        },
        {
            title: 'Provider',
            dataIndex: 'provider',
            key: 'provider',
        }
    ];

    const formStyle = {
        maxWidth: 'none',
        background: 'white',
        borderRadius: token.borderRadiusLG,
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: 12,
    };
    const handleCopyToClipboard = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => {
                message.success('Copied to clipboard');
            })
            .catch((err) => {
                console.error('Failed to copy: ', err);
                message.error('Failed to copy');
            });
    }

    const calculatorProfit = (record) => {
        if (record?.est_settlement_amount) {
            const total_cost = record?.items?.reduce((total, item) => total + (item?.total_cost ?? 0), 0);
            return formatNumber(record?.est_settlement_amount * RATE_EURO_TO_USD - total_cost, 2);
        }
        return 'N/A';
    }

    const calculatorTotalCost = (record) => {
        if (record?.items) {
            const total_cost = record?.items?.reduce((total, item) => total + (item?.total_cost ?? 0), 0);
            return formatNumber(total_cost, 2);
        }
        return 'N/A';
    }

    const calculatorStatusOrder = (record) => {
        const status = statusOrderMap[record?.status] || statusOrderMap.waiting;
        return <Tag icon={status.icon} color={status.color}>{status.text}</Tag>;
    }

    const handleSaveUpdatePrinters = async (data) => {
        const params = {
            supplier_id: data?.supplier_id,
            isExport: data?.isExport,
            status: data?.status ?? null,
            order_ids: selectedRows?.map(item => item?.order_id),
            updatedBy: userReducer?.user_info?.id ?? '',
        }
        setLoading(true);
        const res = await updateAndExportOrderBySelected(params);
        setLoading(false);
        if (res && res.status === 1) {
            message.success('Cập nhật thông tin thành công');
            if (data?.isExport) {
                window.open(res?.data?.download_link);
            }
            getDataOrders(currentPage, dayjs(form.getFieldValue("date")[0]).format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), dayjs(form.getFieldValue("date")[1]).format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), true)
        } else {
            message.error(res?.msg ?? 'Cập nhật thông tin thất bại');
        }
    }

    const rowSelection = {
        selectedRowKeys: selectedRowKeys,
        onChange: (newSelectedRowKeys, newSelectedRows) => {
            setSelectedRows(newSelectedRows);
            setSelectedRowKeys(newSelectedRowKeys);
        },
        preserveSelectedRowKeys: true,
    };

    const getDataProviders = async () => {
        try {
            const params = {
                keyword: '',
            }
            setLoading(true);
            const res = await getListProvider(params);
            consoleLogUtil("getListProvider", res);
            setLoading(false);
            if (res && res.status === 1) {
                setProviders([...res?.data?.data]);
            } else {
                message.error(res.message);
                setProviders([]);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }
    }

    const getDataSKUs = async () => {
        try {
            const params = {
                keyword: '',
            }
            const res = await searchSkuPrintlogistic(params);
            consoleLogUtil("searchSkuPrintlogistic", res);
            if (res && res.status === 1) {
                setSkus([...res?.data]);
            } else {
                message.error(res.message);
                setSkus([]);
            }
        } catch (error) {
            console.log('error', error);
        }
    }

    const getDataOrderDetail = async (order_id) => {
        try {
            const params = {
                order_id: order_id
            };
            setLoading(true);
            const res = await getOrderDetailById(params);
            setLoading(false);
            consoleLogUtil("getOrderDetailById", res);
            if (res && res?.status === 1) {
                setOrderSelected({ ...res?.data });
                setIsModalOpen(true);
            } else {
                message.warning(res?.msg ?? 'Get order detail failed');
            }
        } catch (error) {
            message.error('System error');
            setLoading(false);
        }

    }

    const getDataItemDetail = async (id) => {
        try {
            const params = {
                id: id
            };
            setLoading(true);
            const res = await getOrderItemDetail(params);
            setLoading(false);
            consoleLogUtil("getDataItemDetail", res);
            if (res && res?.status === 1) {
                setItemSelected({ ...res?.data });
                setIsModalItemOpen(true);
            } else {
                message.warning(res?.msg ?? 'Get order detail failed');
                setItemSelected(null);
            }
        } catch (error) {
            message.error('System error');
            setLoading(false);
        }

    }

    const handleRemoveSelected = (id) => {
        const newSelectedRows = selectedRows.filter(item => item?.id !== id);
        const newSelectedRowKeys = selectedRowKeys.filter(item => item !== id);
        setSelectedRows([...newSelectedRows]);
        setSelectedRowKeys([...newSelectedRowKeys]);
    }

    const handleClearSelected = () => {
        setSelectedRows([]);
        setSelectedRowKeys([]);
    }

    const handleChangeOptionTime = (value) => {
        setOptionTime(value);
        switch (value) {
            case 1:
                form.setFieldsValue({
                    date: [dayjs().startOf('day'), dayjs().endOf('day')]
                });
                break;
            case 2:
                form.setFieldsValue({
                    date: [dayjs().startOf('day').subtract(1, 'day'), dayjs().endOf('day').subtract(1, 'day')]
                });
                break;
            case 3:
                form.setFieldsValue({
                    date: [dayjs().startOf('day').subtract(7, 'day'), dayjs().endOf('day')]
                });
                break;
            case 4:
                form.setFieldsValue({
                    date: [dayjs().startOf('month'), dayjs().endOf('day')]
                });
                break;
            case 5:
                form.setFieldsValue({
                    date: [
                        dayjs().subtract(1, 'month').startOf('month'),
                        dayjs().subtract(1, 'month').endOf('month')
                    ]
                });
                break;
        }
        handleClearSelected();
        setCurrentPage(1);
        getDataOrders(1, dayjs(form.getFieldValue("date")[0]).format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), dayjs(form.getFieldValue("date")[1]).format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), true);
    }

    const handleChangeSortType = (value) => {
        setSortType(value);
        handleClearSelected();
        setCurrentPage(1);
        getDataOrders(1, dayjs(form.getFieldValue("date")[0]).format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), dayjs(form.getFieldValue("date")[1]).format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), true, null, value);
    }

    const handleExportOrderSelected = async (data) => {
        try {
            const params = {
                order_ids: selectedRows.map(item => item?.order_id),
                supplier_id: data?.supplier_id,
            }
            setLoading(true);
            const res = await exportOrderSelected(params);
            setLoading(false);
            if (res && res.status === 1) {
                message.success('Xuất excel thành công');
                window.open(res?.data?.download_link);
            } else {
                message.error(res?.msg ?? 'Xuất excel thất bại');
            }
        } catch (error) {
            setLoading(false);
            message.error('Xuất excel thất bại');
        }
    }
    const handleExportAll = async () => {
        try {
            const params = {
                ids: selectedRows.map(item => item?.id),
                isUpdateTime: false
            }
            setLoading(true);
            const res = await exportOrderBySelected(params);
            setLoading(false);
            if (res && res.status === 1) {
                message.success('Xuất excel thành công');
                window.open(res?.data?.download_link);
            } else {
                message.error(res?.msg ?? 'Xuất excel thất bại');
            }
        } catch (error) {
            setLoading(false);
            message.error('Xuất excel thất bại');
        }

    }

    const getDataShops = async (showLoading) => {
        try {
            const params = {
                name: '',
            }
            if (showLoading) setLoading(true);
            const res = await getListShops(params);
            if (showLoading) setLoading(false);
            if (res && res.status === 1) {
                const lstShop = res?.data?.data;
                const filteredShops = filterShopsByUser(lstShop, userReducer);
                setDataShops([...filteredShops?.map((item, index) => ({ value: item?.shop_id, label: `${index + 1}. ${item?.custom_code} - ${item?.shop_name}` }))]);
            } else {
                message.error(res.message);
                setDataShops([]);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }
    }

    const getDataOrders = async (page, startTime, endTime, showLoading, pageSize, sort_type) => {
        try {
            const params = {
                keyword: form.getFieldValue('keyword') ?? '',
                from_date: startTime,
                to_date: endTime,
                limit: pageSize ?? currentPageSize,
                page: page,
                shop_ids: form.getFieldValue('shop_ids') ?? '',
                supplier_id: form.getFieldValue('supplier_id') ?? '',
                user_id: userReducer?.user_info?.id ?? '',
                status: form.getFieldValue('status') ?? '',
                has_sku_print_id: form.getFieldValue('has_sku_print_id') === 1 ? true : (form.getFieldValue('has_sku_print_id') === 0 ? false : null),
                sort_order: sort_type ?? sortType,
            }
            setLoading(true);
            const res = await getListOrders(params);
            setLoading(false);
            consoleLogUtil("getListOrders", res);
            if (res && res.status === 1) {
                setData([...res?.data?.data]);
                setCurrentPage(res?.data?.pagination?.page);
                setCurrentPageSize(res?.data?.pagination?.limit);
                setTotalRecords(res?.data?.pagination?.total_records);
            } else {
                setData([]);
                setCurrentPage(1);
                setCurrentPageSize(20);
                setTotalRecords(0);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }
    }


    const onFinish = async (dataForm) => {
        handleClearSelected();
        setCurrentPage(1);
        getDataOrders(1, dayjs(form.getFieldValue("date")[0]).format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), dayjs(form.getFieldValue("date")[1]).format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), true);
    };

    const updateSupplierAndExportGoogleSheet = async (supplier_id, orderId, sku_print_id) => {
        try {
            const params = {
                supplier_id: supplier_id,
                order_id: orderId,
                user_id: userReducer?.user_info?.id ?? '',
                sku_code: skus?.filter(s => s?.id === sku_print_id)?.length > 0 ? skus?.filter(s => s?.id === sku_print_id)[0]?.sku_code : '',
                sku_name: skus?.filter(s => s?.id === sku_print_id)?.length > 0 ? skus?.filter(s => s?.id === sku_print_id)[0]?.sku_name : '',
            }
            const res = await updateSupplierByOrderId(params);
            if (res && res.status !== 1) {
                message.error(res?.msg ?? 'Cập nhật và xuất google sheet thất bại');
            }
        } catch (error) {
            setLoading(false);
            message.error('Cập nhật và xuất excel thất bại');
        }
    }

    const callApiUpdateOrderStatus = async (orderInfo) => {
        // call api update order
        consoleLogUtil("orderInfo", orderInfo);
        try {
            const params = {
                order_id: orderInfo?.order_info?.order_id,
                status: orderInfo?.status,
                user_id: userReducer?.user_info?.id,
                tracking_number: orderInfo?.tracking || '',
                provider_id: orderInfo?.provider || '',
                provider_name: providers?.filter(p => p?.provider_id === orderInfo?.provider)?.length > 0 ? providers?.filter(p => p?.provider_id === orderInfo?.provider)[0]?.name : '',
                sku_print_id: orderInfo?.sku_id || null,
                supplier_id: orderInfo?.supplier_id || null,
                isSkipAutoUpdateTiktok: orderInfo?.isSkipAutoUpdateTiktok,
            }
            if (orderInfo?.order_info?.supplier_id !== orderInfo?.supplier_id && orderInfo?.supplier_id) {
                // call api update supplier and export google sheet
                updateSupplierAndExportGoogleSheet(orderInfo?.supplier_id, orderInfo?.order_info?.order_id, orderInfo?.sku_id);
            }
            setLoading(true);
            const res = await updateOrderById(params);
            setLoading(false);
            if (res && res.status === 1) {
                message.success('Update order success');
                getDataOrders(currentPage, dayjs(form.getFieldValue("date")[0]).format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), dayjs(form.getFieldValue("date")[1]).format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), true)
            } else {
                message.error('Update order failed');
            }
        } catch (error) {
            console.log('error', error);
            setLoading(false);
        }
    }
    const handleOnSaveItemDetail = async (data) => {
        try {
            const params = {
                id: data?.id,
                tracking_number: data?.tracking_number,
                provider_id: data?.provider,
                provider_name: providers?.filter(p => p?.provider_id === data?.provider)?.length > 0 ? providers?.filter(p => p?.provider_id === data?.provider)[0]?.name : '',
                status: data?.status,
                user_id: userReducer?.user_info?.id,
            }
            setLoading(true);
            const res = await updateOrderItem(params);
            setLoading(false);
            consoleLogUtil("updateOrderItem", res);
            if (res && res.status === 1) {
                message.success('Update item success');
                getDataOrders(currentPage, dayjs(form.getFieldValue("date")[0]).format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), dayjs(form.getFieldValue("date")[1]).format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), true)
            } else {
                message.error('Update item failed');
            }
        } catch (error) {
            console.log('error', error);
            setLoading(false);
        }
    }
    const getDataSuppiler = async () => {
        try {
            const params = {
                keyword: '',
            }
            const res = await getListSuppiler(params);
            if (res && res.status === 1) {
                setPrinters([...res?.data]);
            } else {
                message.error(res.message);
                setPrinters([]);
            }
        } catch (error) {
            console.log('error', error);
        }


    }
    useEffect(() => {
        Promise.all([getDataShops(), getDataProviders(), getDataSuppiler(), getDataSKUs()]);
    }, [])

    useEffect(() => {
        if (form) {
            form.setFieldsValue(initialValues);
            getDataOrders(1, dayjs().startOf('day').format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), dayjs().endOf('day').format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), true)
        }
    }, [form])

    const ExpandedTable = React.memo(({ columns, dataSource }) => {
        return (
            <Table
                columns={columns}
                dataSource={dataSource}
                bordered
                pagination={false}
                onRow={(record, rowIndex) => {
                    return {
                        onClick: event => {
                            getDataItemDetail(record?.id);
                        },
                        onMouseEnter: event => {
                            event.currentTarget.style.cursor = 'pointer';
                        }, // hover row
                    };
                }}

            />
        );
    });

    const expandedRowRender = (record) => {
        const childData = record.items || [];

        return <ExpandedTable
            columns={expandColumns}
            dataSource={childData}
        />
    };

    return (
        <div className='container-content'>

            <Form form={form} name="advanced_search" style={formStyle} onFinish={onFinish}>
                <Row gutter={24}>
                    <Col span={4}>
                        <Form.Item
                            name={'keyword'}
                        >
                            <Input placeholder={'Order Id, product name '} />
                        </Form.Item>
                    </Col>

                    <Col span={3}>
                        <Form.Item
                            name="status"
                        >
                            <Select
                                showSearch
                                allowClear
                                placeholder={'Chọn trạng thái'}
                                style={{ width: '100%', height: 40 }}
                                defaultActiveFirstOption={false}
                                filterOption={filterOption}
                                notFoundContent={null}
                                options={STATUS_ORDER.filter(status => status.type.includes(1))}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item
                            name="shop_ids"
                        >
                            <Select
                                showSearch
                                allowClear
                                mode='multiple'
                                maxTagCount={'responsive'}
                                placeholder={'Shop name'}
                                style={{ width: '100%', height: 40 }}
                                defaultActiveFirstOption={false}
                                filterOption={filterOption}
                                notFoundContent={null}
                                options={dataShops}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={3}>
                        <Form.Item
                            name="supplier_id"
                        >
                            <Select
                                showSearch
                                allowClear
                                placeholder={'Printer name'}
                                style={{ width: '100%', height: 40 }}
                                defaultActiveFirstOption={false}
                                filterOption={filterOption}
                                notFoundContent={null}
                                options={printers?.map((item, index) => ({ value: item?.id, label: `${index + 1}. ${item?.name}` }))}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={3}>
                        <Form.Item
                            name="has_sku_print_id"
                        >
                            <Select
                                showSearch
                                allowClear
                                placeholder={'SKU status'}
                                style={{ width: '100%', height: 40 }}
                                defaultActiveFirstOption={false}
                                filterOption={filterOption}
                                notFoundContent={null}
                                options={TYPE_STATUS_SKU}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="date"
                        >
                            <RangePicker
                                showTime
                                allowClear={false}
                                style={{ width: '100%', height: 40 }}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={1}>
                        <Space size="small">
                            <Tooltip title="Tìm kiếm">
                                <Button type="primary" htmlType="submit">
                                    <SearchOutlined />
                                </Button>
                            </Tooltip>
                            {/* {
                                userReducer?.roles?.filter(r => r?.id === '1')?.length > 0 ?
                                    <Tooltip title="Export CSV by select order">
                                        <Button style={{ background: selectedRows.length > 0 ? '#ffde9f' : '#CCC' }} disabled={loading || selectedRows.length > 0 ? false : true} onClick={handleExportAll}>
                                            <SendOutlined style={{ color: 'black', fontWeight: '500', fontSize: 14 }} />
                                        </Button>
                                    </Tooltip> : null
                            } */}

                        </Space>
                    </Col>
                </Row>
                <Row style={{ justifyContent: 'flex-end' }}>
                    <Space>
                        <Segmented
                            value={sortType}
                            options={SORT_TYPE}
                            onChange={handleChangeSortType}
                        />
                        <Segmented
                            value={optionTime}
                            options={OPTION_TIME}
                            onChange={handleChangeOptionTime}
                        />
                    </Space>


                </Row>
            </Form>
            {
                selectedRows.length > 0
                    ?
                    <div style={{ marginBottom: 12 }}>
                        <span
                            style={{ color: 'red', cursor: 'pointer' }}
                            onClick={() => setShowModalSelected(true)}>
                            Selected {selectedRows.length} orders
                        </span>
                        <Tooltip title="Delete selected">
                            <Button type='link' disabled={selectedRows.length > 0 ? false : true} onClick={handleClearSelected}>
                                <CloseCircleOutlined style={{ color: 'red', fontWeight: '500', fontSize: 14 }} />
                            </Button>
                        </Tooltip>
                        <Tooltip title="Cập nhật nhà in cho các đơn hàng đã lựa chọn">
                            <Button type='primary' disabled={selectedRows.length > 0 ? false : true} onClick={() => setShowModalUpdatePrinter(true)}>
                                Cập nhật nhà in
                            </Button>
                        </Tooltip>
                        <div style={{ display: 'inline-block', width: 12 }}></div>
                        <Tooltip title="Xuất excel các order đã lựa chọn">
                            <Button icon={<FileExcelOutlined />} danger disabled={selectedRows.length > 0 ? false : true} onClick={() => setShowModalExportOrderSelected(true)}>
                                Xuất excel
                            </Button>
                        </Tooltip>
                    </div> : null
            }
            <Table
                components={HeaderTableCus}
                columns={columns}
                expandable={{ expandedRowRender, defaultExpandedRowKeys: ['0'] }}
                dataSource={data}
                bordered
                rowSelection={rowSelection}
                rowKey={(record) => record?.id}
                scroll={{ x: 'max-content', y: 600 }}
                onRow={(record, rowIndex) => {
                    return {
                        onClick: event => {

                        }, // click row
                        onMouseEnter: event => {
                            event.currentTarget.style.cursor = 'pointer';
                        }, // hover row
                    };
                }}
                pagination={{
                    pageSize: currentPageSize,
                    current: currentPage,
                    total: totalRecords,
                    onChange: (page, size) => {
                        setCurrentPage(page);
                        getDataOrders(page, dayjs(form.getFieldValue("date")[0]).format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), dayjs(form.getFieldValue("date")[1]).format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), true, size);
                    },
                    showSizeChanger: true,
                    showTotal: (total) => `Total ${total} orders`,
                    pageSizeOptions: ['20', '30', '50'],
                    onShowSizeChange: (current, size) => {
                        setCurrentPageSize(size);
                        setCurrentPage(1);
                        getDataOrders(1, dayjs(form.getFieldValue("date")[0]).format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), dayjs(form.getFieldValue("date")[1]).format(DATE_FORMAT.YYYYMMDDHHMMSS_FORMAT), true, size);
                    }
                }}
            />

            <OrderDetailModal
                visible={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                order={orderSelected}
                providers={providers}
                onSave={callApiUpdateOrderStatus}
                printers={printers}
                skus={skus}
            />

            <ItemDetailModal
                visible={isModalItemOpen}
                onClose={() => setIsModalItemOpen(false)}
                item={itemSelected}
                onSave={handleOnSaveItemDetail}
                providers={providers}
            />

            <ModalSelectedOrder
                visible={showModalSelected}
                data={selectedRows}
                onCancel={() => setShowModalSelected(false)}
                onDelete={handleRemoveSelected}
            />
            <ModalExportOrderSelected
                visible={showModalExportOrderSelected}
                onCancel={() => setShowModalExportOrderSelected(false)}
                onSave={(data) => handleExportOrderSelected(data)}
                printers={printers}
            />
            <ModalUpdatePrintOders
                visible={showModalUpdatePrinter}
                onCancel={() => setShowModalUpdatePrinter(false)}
                onSave={(data) => handleSaveUpdatePrinters(data)}
                printers={printers}
            />
            <LoadingBase loading={loading} />
        </div>
    )
}
export default React.memo(ListOrderPage);